import { EditLOSV2EventPage } from "./EditLOSV2EventPage";

export default EditLOSV2EventPage;
